<template lang="html">
  <div>
    <div class="con_wrap">
      <h1 class="title" @click="backHome()"> 	&#60; 가이드</h1>
    </div>
    <h1 class="logo">
      <img src="../../../../assets/images/introMain/logo.png" alt="">
    </h1>
  <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
    <swiper-slide id="slide1">
      <div>
        <img class="main" src="../../../../assets/images/introToday/main.png" alt="">
        <img class="main_btn" src="../../../../assets/images/introToday/main_btn.png" alt="">
        <img class="caution" src="../../../../assets/images/introToday/caution.png" alt="">
        <div class="caution_btn">
          시험 시작하기
        </div>
      </div>
          <p class="speech1">
              <span>오늘 문제</span>에 대해 함께 알아볼까요?
          </p>
    </swiper-slide>
    <swiper-slide id="slide2">
      <div>
        <img class="test" src="../../../../assets/images/introToday/test.png" alt="">
        <img class="finger" src="../../../../assets/images/introToday/finger.png" alt="">
        <div class="tab">

        </div>
      </div>
      <p class="speech2">
          <span>오늘 문제</span>는 각 <span>과목별</span> <br>
          랜덤한 <span>3개</span>의 문제가 주어져요 :)
      </p>
    </swiper-slide>
    <swiper-slide id="slide3">
      <div>
        <img class="test2" src="../../../../assets/images/introToday/test.png" alt="">
        <img class="circle" src="../../../../assets/images/introToday/circle.gif" alt="">
        <img class="bg" src="../../../../assets/images/introToday/bg.png" alt="">
        <img class="alert" src="../../../../assets/images/introToday/alert.png" alt="">

      </div>
      <p class="speech3">
          <span>기회</span>는 하루에 <span>한번</span>뿐이니 <br>
          <span>제출 전 확인</span>은 필수!
      </p>
    </swiper-slide>
    <swiper-slide id="slide4">
      <div>
        <img class="resolt" src="../../../../assets/images/introToday/resolt.png" alt="">
        <img class="banner" src="../../../../assets/images/introToday/banner.png" alt="">
      </div>

      <p class="speech4">
          <span>종료</span>한 뒤에는 <br>
          결과를 확인할 수 있어요 :)
      </p>
      <p class="speech4_1">
        게다가 <span>포인트</span> 지급까지! <br>
        지금 바로 <span>시작</span> 해볼까요?
      </p>
    </swiper-slide>
  </swiper>
  <div class="swiper-pagination"></div>
  <div class="skip">
      <p><a href="#">지금 풀러 가기</a></p>
  </div>
</div>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
<script>

import '../../../../assets/css/intro/test/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  mounted() {
    var windowHeight = $(window).height();
      $(".main , .main_btn").delay(300).fadeIn(function(){
                  $(".speech1").delay(500).fadeIn();

                    if(windowHeight < 500) {
                      $(".main_btn").delay(1000).queue(function(){
                        $(".main").delay(500).fadeOut();
                        $(".main_btn").delay().css({
                          "top" : "30%" ,
                          "left" : "50%" ,
                          "width" : "100px",
                          "transition" : "all 1s ease",
                          "box-shadow" : " 0 6px 20px 0 rgb(0 0 0 / 3%)",
                        })
                    }).dequeue();
                    $(".caution").delay(1500).fadeIn();
                    $(".caution_btn").delay(2000).fadeIn().css({
                      "box-shadow" : "0 2px 4px 0 rgb(0 0 0 / 15%), 0 3px 10px 0 rgb(0 0 0 / 14%)",
                    });
                    } else {
                      $(".main_btn").delay(1000).queue(function(){
                        $(".main").delay(500).fadeOut();
                        $(".main_btn").delay().css({
                          "top" : "25%" ,
                          "left" : "50%" ,
                          "width" : "180px",
                          "transition" : "all 1s ease",
                          "box-shadow" : " 0 6px 20px 0 rgb(0 0 0 / 3%)",
                        })
                    }).dequeue();
                    $(".caution").delay(1500).fadeIn();
                    $(".caution_btn").delay(2000).fadeIn().css({
                      "box-shadow" : "0 2px 4px 0 rgb(0 0 0 / 15%), 0 3px 10px 0 rgb(0 0 0 / 14%)",
                    });
                    }
                })
  },
  methods: {
    backHome() {
      this.$router.push('/pages/intro-main')
    },
  },
    data() {
        return {
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination',
                    clickable:true
                },
                on: {
                  transitionStart: function(){
                    $(".swiper-slide div img , .caution_btn , .tab").not(this).stop().hide();
                    $(".swiper-slide p , .icon").not(this).stop().hide();
                  },
                  transitionEnd: function(){
                    var currentIndex = this.realIndex;
                    var windowHeight = $(window).height();

                    switch(currentIndex) {
                      case 0 :  $(".main , .main_btn").delay(300).fadeIn(function(){
                                  $(".speech1").delay(500).fadeIn();

                                    if(windowHeight < 500) {
                                      $(".main_btn").delay(1000).queue(function(){
                                        $(".main").delay(500).fadeOut();
                                        $(".main_btn").delay().css({
                                          "top" : "30%" ,
                                          "left" : "50%" ,
                                          "width" : "100px",
                                          "transition" : "all 1s ease",
                                          "box-shadow" : " 0 6px 20px 0 rgb(0 0 0 / 3%)",
                                        })
                                    }).dequeue();
                                    $(".caution").delay(1500).fadeIn();
                                    $(".caution_btn").delay(2000).fadeIn().css({
                                      "box-shadow" : "0 2px 4px 0 rgb(0 0 0 / 15%), 0 3px 10px 0 rgb(0 0 0 / 14%)",
                                    });
                                    } else {
                                      $(".main_btn").delay(1000).queue(function(){
                                        $(".main").delay(500).fadeOut();
                                        $(".main_btn").delay().css({
                                          "top" : "25%" ,
                                          "left" : "50%" ,
                                          "width" : "180px",
                                          "transition" : "all 1s ease",
                                          "box-shadow" : " 0 6px 20px 0 rgb(0 0 0 / 3%)",
                                        })
                                    }).dequeue();
                                    $(".caution").delay(1500).fadeIn();
                                    $(".caution_btn").delay(2000).fadeIn().css({
                                      "box-shadow" : "0 2px 4px 0 rgb(0 0 0 / 15%), 0 3px 10px 0 rgb(0 0 0 / 14%)",
                                    });
                                    }
                                })
                                break;

                      case 1 : if(windowHeight < 500) {
                                  $(".main_btn").stop().css({
                                    "width": "75px",
                                    "left": "30%",
                                    "top": "51.6%",
                                  })
                                } else {
                                  $(".main_btn").stop().css({
                                    "width": "113px",
                                    "left": "23.6%",
                                    "top": "54.9%",
                                  })
                                }
                                $(".test").delay(500).fadeIn();
                                $(".speech2").delay(1000).fadeIn();
                                $(".finger").delay(1500).fadeIn().fadeOut();
                                $(".tab").delay(2000).fadeIn();

                                break;

                      case 2 : $(".test2").stop().fadeIn();

                                  var gifSource = $('.circle').attr('src');
                                  $('.circle').attr('src', "");
                                  $('.circle').attr('src', gifSource+"?"+new Date().getTime());

                                  $(".circle").delay(500).fadeIn();
                                  $(".speech3").delay(500).fadeIn();
                                  $(".circle").delay(500).fadeOut();
                                  $(".alert , .bg").delay(1500).fadeIn();

                                  $(".banner").css({
                                    "width" : "300px",
                                    "top" : "45%"
                                  })
                                break;

                      case 3 : $(".resolt , .banner").fadeIn();
                                $(".speech4").delay(500).fadeIn();
                                if(windowHeight < 400) {
                                  $(".banner").delay(1000).queue(function(){
                                    $(".banner").css({
                                      "max-width" : "250px",
                                      "width" : "250px",
                                      "transition" : "all 1s ease",
                                      "top" : "48%"
                                    }).dequeue();
                                  })
                                  $(".speech4").delay(1000).fadeOut(function(){
                                    $(".speech4_1").fadeIn();
                                  });
                                } else {
                                  $(".banner").delay(1000).queue(function(){
                                    $(".banner").css({
                                      "width" : "400px",
                                      "transition" : "all 1s ease",
                                      "top" : "52%"
                                    }).dequeue();
                                  })
                                  $(".speech4").delay(1000).fadeOut(function(){
                                    $(".speech4_1").fadeIn();
                                  });
                                }

                                break;

                      }
                   }
                }
             }
         }
    },
    components: {
        swiper,
        swiperSlide
    },
}


</script>

<style lang="css" scoped>
* {
    margin: 0;
    padding: 0;
    list-style: none;
    box-sizing: border-box;
}
#slide1 {
  z-index: 3
}
#sec{
  border: 1px solid red;
}
p {
  color: black;
  font-family: 'Noto Sans KR', sans-serif;
}
.con_wrap {
  display: flex;
  position: fixed;
  width: 90%;
  margin: 0 auto;
  padding: 40px 15px 20px 15px;
  z-index: 5;
}
.title {
  font-size: 1.3em;
  color: #1E90FF;
}
.back {
  height: 45px;
  padding: 15px 0;
}
.back img {
  width: 30px;
}
.logo {
  position: fixed;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  height: 80px;
  text-align: center;
  border-radius: 10px;
  box-shadow : 0 2px 4px 0 rgb(0 0 0 / 15%), 0 3px 10px 0 rgb(0 0 0 / 14%);
  z-index: 5;

}
.logo img {
  width: 150px;
  margin-top: 20px;
}
.swiper-slide {
    height: 100%;
    font-size: 18px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    position: relative;
}

.swiper-slide div {
  position: relative;
  width: 225px;
  height: 600px;
}
.swiper-slide div img {
    position: absolute;
    width: 300px;
    left: 50%;
    top: 45%;
    transform: translate(-50% , -50%);
    display: none;
}
.swiper-slide div .main_btn {
  width: 113px;
  left: 24%;
  top: 54.9%;
  z-index: 2
}
.swiper-slide div .caution {
  z-index: 1
}
.swiper-slide div .caution_btn {
  position: absolute;
  left: 50%;
  top: 60%;
  transform: translate(-50% , -50%);
  width: 140px;
  height: 40px;
  background-color: #fe9f43;
  border-radius: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 0.8em;
  font-weight: lighter;
  color:white;
  z-index: 2;
  display: none;
  animation: ani 1s infinite;
}
@keyframes ani {
  from {
    transform: translate(-50% , -50%);
  } to {
    transform: translate(-50% , -40%);
  }
}
.swiper-slide div.tab {
  position: absolute;
  top: 64.5%;
  left: 7.5%;
  width: 7px;
  height: 7px;
  border-radius: 100%;
  background-color: #1d9cd3;
  box-shadow: 0 1px 3px 0 #1d9cd3;
  display: none;

}
.swiper-slide div .test {
  width: 350px;
}
.swiper-slide p {
    font-weight: bold;
    text-align: center;
    display: none;
    position: absolute;
    top: 70%;
}
.swiper-slide div .finger {
  top: 64%;
  left: -20%
}
.swiper-slide p span {
    color: #1d9cd3;
}

.skip {
    position: absolute;
    width: 100%;
    height: 80px;
    background-color: #1d9cd3;
    left: 0;
    bottom: 0;
    z-index: 2;
}

.skip p {
    text-align: center;
    line-height: 80px;
    font-weight: bold;
    font-size: 1.3em;
}
.skip p a {
    text-decoration: none;
    color: white;
}
.banner {
  width: 200px;
}

@media screen and (max-height:450px) {
    .logo {
      width: 20%;
      top: 5%;
    }
    .logo img {
        width: 100px;
        margin-top: 25px;
    }
    .swiper-slide {
        height: 100%;
        flex-direction: row;
        justify-content: space-between;
    }
    .swiper-slide div .main_btn {
      width: 75px;
      max-width: 120px;
      left: 30%;
      top: 51.6%;
    }
    .swiper-slide div .caution_btn {
      width: 100px;
      height: 30px;
      font-size: 0.6em;
      line-height: 30px;
      left: 0
    }
    .swiper-slide div {
      width: 200px;
      margin-left: 100px
    }
    .swiper-slide div img {
        width: 200px;
    }
    .swiper-slide p {
        left: 50%;
        top: 35%;
        z-index: 10;
        margin-left: 100px;
        margin-bottom: 50px;
    }
    .swiper-slide div .test {
      width: 200px;
    }
    .swiper-slide div .tab {
      width: 5px;
      height: 5px;
      top: 56.1%;
      left: -27.5%;
    }
    .swiper-slide div .finger {
      top: 55%;
      left: 0;
    }
    .swiper-slide div .banner {
      max-width: 200px;
    }
    .swiper-pagination {
      top: 75%;
    }
}
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@300&display=swap');
</style>
